import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

/**
 * Allows the wildcard route to render only when the backend has page information
 * for the requested path. Any failure (typically a 404 for an unknown page)
 * falls back to home.
 */
export const dynamicPageGuard: CanActivateFn = (route) => {
  const http = inject(HttpClient);
  const router = inject(Router);
  const path = route.url.map((segment) => segment.path).join('/');

  if (!path) {
    return router.parseUrl('/');
  }

  return http.get(`/api/page-blocks/page-information/${path}`).pipe(
    map(() => true),
    catchError(() => of(router.parseUrl('/'))),
  );
};
